// export const apiCall="http://127.0.0.1:8000/api/";
// export const mediaUrl="http://127.0.0.1:8000/storage/uploads";
// export const apiCall="https://www.logiprompt.in/gokulam_server/public/api/";
// export const mediaUrl="https://www.logiprompt.in/gokulam_server/public/storage/uploads";
export const apiCall="https://www.gokulamhospital.com/server/public/api/";
export const mediaUrl="https://www.gokulamhospital.com/server/storage/app/public/uploads";
export const googleMapsApiKey='AIzaSyCWED24ut0NZVXBKwkiynWByxmjj__fVcw'

